import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-8',
  templateUrl: './8.component.html',
  styleUrls: ['./8.component.scss'],
})
export class VbGeneral8Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
